import { Component, OnInit, inject } from '@angular/core'
import { NgClass } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject } from 'rxjs'
import {
    TransactionDetailsModalComponent,
    StatusBadgeComponent,
    NegativeCurrencyPipe,
    formatUserName,
} from '../../../../projects/ach-transaction-details/src/public-api'
import { TransactionStatus } from '../../../../projects/ach-transaction-details/src/lib/models'
import { SCENARIO_MAP, SCENARIOS } from './mock-data/transaction-details.mock'
import { environment } from '../environments/environment'

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [TransactionDetailsModalComponent, StatusBadgeComponent, NegativeCurrencyPipe, FormsModule, NgClass],
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    private readonly http = inject(HttpClient)

    hidden = new BehaviorSubject<boolean>(true)
    selectedScenario = 'settled'
    selectedTransactionId = '583914245518940015'
    sessionId = 'demo-session-001'
    canExport = true
    useMockData = environment.useMockData

    realTransactionId = ''
    sessionStatus: 'idle' | 'loading' | 'ready' | 'error' = 'idle'
    sessionError = ''
    scenarios = SCENARIOS

    errorScenarios = [
        { key: 'error-401', label: '401 — Session Expired', id: 'error-401' },
        { key: 'error-404', label: '404 — Not Found', id: 'error-404' },
        { key: 'error-500', label: '500 — Server Error', id: 'error-500' },
        { key: 'error-502', label: '502 — Bad Gateway', id: 'error-502' },
    ]

    allStatuses: TransactionStatus[] = [
        TransactionStatus.Pending,
        TransactionStatus.Submitted,
        TransactionStatus.Approved,
        TransactionStatus.Declined,
        TransactionStatus.Funded,
        TransactionStatus.Settled,
        TransactionStatus.Returned,
        TransactionStatus.ReturnRetry,
        TransactionStatus.PostSettleReturn,
        TransactionStatus.Refunded,
        TransactionStatus.Voided,
        TransactionStatus.Cancelled,
        TransactionStatus.Failed,
        TransactionStatus.TimedOut,
        TransactionStatus.NocReceived,
        TransactionStatus.Unsettled,
        TransactionStatus.RefundFailed,
        TransactionStatus.PartiallyRefunded,
        TransactionStatus.PartialRefundFailed,
    ]

    currencySamples: (number | null)[] = [1250, -875.50, 0, null]

    selectScenario(key: string): void {
        this.selectedScenario = key
        this.selectedTransactionId = SCENARIO_MAP[key].transactionId
        this.openModal()
    }

    selectErrorScenario(id: string): void {
        this.selectedTransactionId = id
        this.openModal()
    }

    onTransactionSelected(id: string): void {
        this.selectedTransactionId = id
    }

    ngOnInit(): void {}

    openModal(): void {
        this.hidden.next(false)
    }

    openWithRealData(): void {
        if (!this.realTransactionId || this.sessionStatus !== 'ready') return
        this.selectedTransactionId = this.realTransactionId
        this.openModal()
    }

    createSession(): void {
        this.sessionStatus = 'loading'
        this.sessionError = ''

        this.http.post<{ sessionId: string; expiresAt: string }>(
            `${environment.bffBaseUrl}/api/v1/sessions`,
            {
                userId: 'demo-user',
                organization: 'Wellfit',
                consumingApp: 'Demo',
                displayName: 'Demo User',
                permissions: ['payments.export-ach-transaction-details'],
            },
        ).subscribe({
            next: (response) => {
                this.sessionId = response.sessionId
                this.sessionStatus = 'ready'
            },
            error: (err) => {
                this.sessionStatus = 'error'
                this.sessionError = err.status === 0
                    ? 'Cannot reach BFF. Is it running on localhost:7071?'
                    : `Session creation failed (${err.status})`
            },
        })
    }

    formatUserName(name: string, org?: string): string {
        return formatUserName(name, org)
    }
}
